<template>
  <header class="header">
    <div class="wrapper">
      <div class="col12 logo">
        <a>
          <img src="../../../../../../../WebApp/Public/images/bocco_emo_necolico_logo.svg" width="300" alt="BOCCO emo LTEモデル Powered by ネコリコ">
          <strong>ネコリコチャンネル with LTE 機器レンタルプラン <br class="off-sp" />申込サイト</strong>
        </a>
      </div>
    </div>
  </header>
</template>